export default {
    // tableName: 'materials',
    display: ['materialEs'],
    attributes: {
        type: {
            type: 'string',
            required: true,
        },
        materialEs: {
            type: 'string',
            required: true,
        },
        materialEn: {
            type: 'string',
            required: true,
        },
        impoIva: {
            type: 'string',
            required: true,
        },
        ExpoIva: {
            type: 'string',
            required: true,
        },
    },
}


// WEBPACK FOOTER //
// ./src/models/Materials.js